import React, { useEffect } from 'react';
import { Modal } from '@uniquegood/realworld-studio-design';
import { useChannelLimit } from '@/hooks/useChannelLimit';
import { useIsAdminSelector, useUser } from '@/hooks';
import { isSchoolAdminRole } from '@/utils/roleAccess';

interface Props {
  children: React.ReactNode;
  targetName: string;
}

export default function ChannelLimitGuard({ children, targetName }: Props) {
  const { isLimitExceeded, checkLimitAndShowModal, modal } = useChannelLimit();
  const { data: isAdmin } = useIsAdminSelector();
  const { data: user } = useUser();
  const isPrivilegedRole = Boolean(isAdmin || isSchoolAdminRole(user?.role));

  useEffect(() => {
    if (isLimitExceeded) {
      checkLimitAndShowModal(targetName);
    }
  }, [isLimitExceeded, targetName]);

  // RealWorld Admin과 School.Admin은 채널 제한에서 제외
  if (isLimitExceeded && !isPrivilegedRole) {
    return <Modal {...modal} />;
  }

  return (
    <>
      {children}
      <Modal {...modal} />
    </>
  );
}
